import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/gardeniabayaldar/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardeniaLaunchConclusion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardeniaLaunchFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardeniaLaunchHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardeniaLaunchSpecification/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardeniaLaunchWelcome/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardeniaLogo/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardenLaunchBanner/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/Gardenia-Bay-By-Aldar/GardenLaunchRegistration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/app/src/components/Desktop/Desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/src/components/Mobile/Mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SplideSlider/index.tsx");
